let suggestions;
const locationSelector = '#location1';
const jobTitleSelector = '#jobtitle';

function toTitleCase(str) {
  return str.replace(/(?:^|\s)\S/g, (match) => match.toUpperCase());
}

const validateInput = (val, suggestionsList) => {
  const isValid = (suggestionsList && suggestionsList.includes(val));

  if (val === '') {
    document.getElementById('addLocation').setAttribute('disabled', 'true');
  } else if (isValid) {
    $('#invalidLocation').hide();
    document.getElementById('addLocation').removeAttribute('disabled');
  } else {
    $('#invalidLocation').show();
    document.getElementById('addLocation').setAttribute('disabled', 'true');
  }
};

const lazyLoadAutocomplete = async () => {
  await import(/* webpackChunkName: "jquery.zipAutocomplete" */ '@static/js/light/vendor/jquery.zipAutocomplete');
  await import(/* webpackChunkName: "zipAutocomplete" */ '@static/css/light/vendor/zipAutocomplete.css');

  $(`${locationSelector}[data-autocomplete-url]`).zipAutocomplete({
    parse: (data) => {
      const seen = {};
      suggestions = data.results.filter((val) => {
        const value = `${val.city}, ${val.admin1_code}`;
        let hasSeen = false;
        if (!seen[value]) {
          seen[value] = 1;
          hasSeen = true;
        }
        return val.city && val.admin1_code && hasSeen;
      }).map((val) => {
        const value = `${val.city}, ${val.admin1_code}`;
        seen[value] = 1;
        return value;
      });

      return suggestions;
    },
  });

  $(`${jobTitleSelector}[data-autocomplete-url]`).zipAutocomplete({
    parse: (data) => {
      suggestions = (data
        ? data.suggestions.reduce((options, option) => [...options, toTitleCase(option.value)], [])
        : []);
      return suggestions;
    },
  });
};

$(`${locationSelector}, ${jobTitleSelector}`).one('focus', () => lazyLoadAutocomplete());

$(`${locationSelector}`).on('change keypress paste focus textInput input', () => {
  const val = $(`${locationSelector}`).val();
  validateInput(val, suggestions);
});

$(`${locationSelector}`).on('blur', () => {
  const val = $(`${locationSelector}`).val();
  const invalidLocation = suggestions && !suggestions.includes(val);

  if (val.length > 0 && invalidLocation) {
    $('#invalidLocation').show();
  }
});

$(`${locationSelector}`).on('input', () => {
  if ($(`${locationSelector}`).attr('data-changed') !== 1) {
    $(`${locationSelector}`).attr('data-changed', 1);
  }
});

$(`${jobTitleSelector}`).on('change keypress paste focus textInput input', () => {
  const val = $(`${jobTitleSelector}`).val();
  validateInput(val, suggestions);
});

$(`${jobTitleSelector}`).on('blur', () => {
  const val = $(`${jobTitleSelector}`).val();
  const invalidLocation = suggestions && !suggestions.includes(val);

  if (val.length > 0 && invalidLocation) {
    $('#invalidLocation').show();
  } else {
    $('#invalidLocation').hide();
  }
});

$(`${jobTitleSelector}`).on('input', () => {
  if ($(`${jobTitleSelector}`).attr('data-changed') !== 1) {
    $(`${jobTitleSelector}`).attr('data-changed', 1);
  }
});

$('.site_content').on('scroll', () => {
  $('.autocomplete-menu').removeClass('autocomplete-show');
  $(locationSelector).blur();
});
